import {observable} from 'mobx';
import {createArrayInstance, ModelProperties} from 'utils';

import {WebPageLanguage} from './web-page-language';
import {WebPageCategory} from './web-page-category';

export class WebPage {
    @observable id!: number;

    @observable route!: string;

    @observable languages?: WebPageLanguage[];

    @observable categories?: WebPageCategory[];

    constructor(page?: ModelProperties<WebPage>) {
        if (page) {
            Object.assign(this, page);
            this.languages = createArrayInstance(WebPageLanguage, page.languages);
            this.categories = createArrayInstance(WebPageCategory, page.categories);
        }
    }
}